// src/components/Navbar.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../images/Logo.png";


function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: "Services", path: "/services" },
    { name: "Installation", path: "/installation" },
    { name: "About", path: "/about" },
  ];

  return (
    <nav className="bg-black shadow-md w-full fixed top-0 left-0 z-50">
      <div className="max-w-7xl mx-auto px-8 md:px-20">
        
        {/* ---------- DESKTOP NAVBAR ---------- */}
        <div className="hidden md:grid grid-cols-3 items-center h-24">

          {/* LEFT — LOGO */}
          <div className="flex items-center space-x-2">
  <img 
    src={logo} 
    alt="Ledot Prime Logo" 
    className="h-10 w-auto object-contain"
  />

  <Link to="/" className="text-3xl font-bold text-gray-200">
    Ledot Prime
  </Link>
</div>


          {/* CENTER — NAV LINKS */}
          <div className="flex justify-center space-x-6">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-white text-sm hover:text-gray-300 font-normal"
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* RIGHT — CONTACT US */}
          <div className="flex justify-end items-center">
            <Link to="/contact">
              <button className="bg-white rounded-full px-4 py-2 text-sm font-semibold text-black">
                Contact Us
              </button>
            </Link>
          </div>
        </div>


       {/* ---------- MOBILE NAVBAR ---------- */}
<div className="md:hidden flex justify-between items-center h-16">
  
  <Link to="/" className="flex items-center space-x-2">
    <img 
      src={logo} 
      alt="Ledot Prime Logo" 
      className="h-8 w-auto object-contain"
    />
    <span className="text-xl font-bold text-gray-200">Ledot Prime</span>
  </Link>

  {/* Mobile Menu Button */}
  <button
    onClick={() => setIsOpen(!isOpen)}
    className="text-white focus:outline-none"
  >
    {isOpen ? <X size={28} /> : <Menu size={28} />}
  </button>
</div>

      </div>

      {/* ---------- MOBILE MENU DROPDOWN ---------- */}
      <div
        className={`md:hidden bg-black px-4 pb-4 space-y-10 transform transition-all duration-200 ease-in-out
        ${isOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0 overflow-hidden"}`}
      >
        {navItems.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className="block text-white text-base font-medium hover:text-gray-300"
            onClick={() => setIsOpen(false)}
          >
            {item.name}
          </Link>
        ))}

        {/* Mobile CONTACT US */}
        <div className="flex justify-center pt-4">
          <Link to="/contact">
            <button className="bg-white rounded-full px-4 py-2 text-sm font-semibold text-black">
              Contact Us
            </button>
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
